import { render, staticRenderFns } from "./sourceManage.vue?vue&type=template&id=1ba417b2"
import script from "./sourceManage.vue?vue&type=script&lang=js"
export * from "./sourceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports